import { rupiah, num } from '../../lib/format';

const Bar = ({ value, tone }) => (
  <div className="h-1.5 w-full rounded-full bg-secondary overflow-hidden mt-1">
    <div className={`h-full rounded-full ${tone}`} style={{ width: `${Math.max(0, Math.min(value, 100))}%` }} />
  </div>
);

export const ProductRanking = ({ rows }) => (
  <div className="bg-card border border-border/60 rounded-xl overflow-hidden">
    <div className="p-5 border-b border-border/60">
      <h3 className="font-display text-lg font-semibold">Pembagian Penjualan per Produk</h3>
      <p className="text-xs text-muted-foreground">Diurutkan dari kontribusi laba tertinggi</p>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="table-product-ranking">
        <thead className="bg-secondary/50 text-left">
          <tr>
            <th className="p-3 font-semibold w-10">#</th>
            <th className="p-3 font-semibold">Produk</th>
            <th className="p-3 font-semibold text-right">Terjual</th>
            <th className="p-3 font-semibold text-right min-w-[140px]">Omzet</th>
            <th className="p-3 font-semibold text-right min-w-[140px]">Laba Bersih</th>
            <th className="p-3 font-semibold text-right">Margin</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-muted-foreground">Belum ada penjualan pada periode ini.</td></tr>}
          {rows.map((r, i) => (
            <tr key={r.key} className="border-t border-border/60" data-testid={`rank-row-${i}`}>
              <td className="p-3 font-display font-semibold text-muted-foreground">{i + 1}</td>
              <td className="p-3 font-medium">{r.label}</td>
              <td className="p-3 text-right tabular-nums">
                {num(r.qty_terjual, 2)} <span className="text-xs text-muted-foreground">({num(r.share_qty, 1)}%)</span>
              </td>
              <td className="p-3 text-right tabular-nums">
                {rupiah(r.omzet)} <span className="text-xs text-muted-foreground">{num(r.share_omzet, 1)}%</span>
                <Bar value={r.share_omzet} tone="bg-blue-500" />
              </td>
              <td className="p-3 text-right tabular-nums">
                <span className="text-emerald-600 dark:text-emerald-400 font-semibold">{rupiah(r.laba_total)}</span> <span className="text-xs text-muted-foreground">{num(r.share_laba, 1)}%</span>
                <Bar value={r.share_laba} tone="bg-emerald-500" />
              </td>
              <td className="p-3 text-right tabular-nums">{num(r.margin, 1)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
